// These are used to determine the state management
// in the App's cache in `react-native`
export const SAVE_STATE = "SAVE_STATE";
export const RESTORE_STATE = "RESTORE_STATE";
